<template>
  <div>
    <select v-model="selected" class="form-control">
      <option v-for="option in options" v-bind:value="option.value">{{ option.text }}</option>
    </select>
  </div>
</template>

<script>
import axios from "axios";
import config from "../../../helpers/config"

export default {
  props: {
    onClick: Function,
    guild_id: Number
  },
  watch: {
    selected: function(newVal, oldVal) {
      // watch it
      this.onClick(newVal);
    }
  },
  mounted() {
    this.getDepartaments();
    this.selected = this.guild_id;
  },
  data() {
    return {
      selected: "",
      options:[]
    };
  },
  methods: {
    onChange(event) {
      this.onClick(event.value);
    },
    getDepartaments() {
      axios
        .get(`${config.urlApi}/guilds`, {})
        .then(response => {
          response.data.forEach(element => {
            this.options.push({
              value: element.id,
              text: element.type
            });
          });
        })
        .catch(function(error) {});
    }
  }
};
</script>
